import { useEffect, useState } from "react";
import { createSearchParams, useNavigate } from "react-router-dom";
import ContactlessSvg from "../contactless.svg";

export default function () {
    const [timer, setTimer] = useState();
    const [rfidValue, setRfidValue] = useState();
    const navigate = useNavigate();
    const [value, setValue] = useState();

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (value) {
                console.log(value);
                setRfidValue(Number(`0x${value.substring(2)}`));
                setValue();
            }
        }, 250);
        return () => clearTimeout(timeout);
    }, [value]);

    const recordValue = (event) => {
        const code = event.keyCode
        const isAlphaNumeric = (code >= 48 && code <= 57) || (code >= 65 && code <= 90) || (code >=97 && code <= 122)
        if(isAlphaNumeric)
            setValue((prevValue) => (prevValue ?? "") + event.key);
    };

    useEffect(() => {
        document.addEventListener("keydown", recordValue);
        return () => document.removeEventListener("keydown", recordValue);
    }, []);

    useEffect(() => {
        if (rfidValue) {
            navigate(
                {
                    pathname: "../leaveRequestForm",
                    search: createSearchParams({
                        badgeId: rfidValue,
                        mode: "kiosk",
                    }).toString(),
                },
                { replace: true },
            );
        }
    }, [rfidValue]);

    return (
        <div style={{ height: "100%", width: "100%" }}>
            <div
                style={{
                    position: "absolute",
                    top: 0,
                    display: "flex",
                    width: "100%",
                    height: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: 50,
                }}
            >
                <div style={{ textAlign: "center" }}>
                    <div style={{ color: "red" }}>
                        <b>
                            <u>RICHIESTA FERIE O PERMESSO</u>
                        </b>
                    </div>
                    <div style={{ marginTop: 50 }}>
                        <img src={ContactlessSvg} height={200} />
                        <div style={{ fontSize: 35 }}>
                            <b>AVVICINARE IL BADGE AL LETTORE</b>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
